module.exports = __webpack_public_path__ + "step4_child_to_parent_son.42b29365.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step4_child_to_parent_son.jpg
// module id = /Am9
// module chunks = 0